export const SEGMENT_ANONYMOUS_ID_COOKIE_NAME = 'ajs_anonymous_id'
